var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _path, _circle6, _path2, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepositReward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 34.834,
    cy: 6.651,
    r: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 5.198,
    cy: 6.651,
    r: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 5.198,
    cy: 19.268,
    r: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub_dot",
    cx: 11.318,
    cy: 12.774,
    r: 1.5,
    transform: "rotate(-34.001 11.318 12.774)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 32.158,
    cy: 22.968,
    r: 1.444
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M35.444 28.798v8.554l-3.286-1.58-3.285 1.58v-8.554"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 32.158,
    cy: 22.968,
    r: 6.373
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M20.966 20.595H3.988V5.168h32.249v6.956"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 20.112,
    cy: 12.774,
    r: 1.5,
    transform: "rotate(-34.001 20.112 12.775)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositReward);
export default __webpack_public_path__ + "static/media/depositReward.6d4d7bcb391e3fcfc927fc05d4a2c34d.svg";
export { ForwardRef as ReactComponent };